/**
 * 샵관리 모바일 웹 공통 스타일 — 터치 타깃 ≥ 44px (ERP 26px 규격은 PC 그리드 화면 한정)
 * 컨셉: 럭셔리 스킨케어 — 웜 화이트 바탕, 딥 레드 포인트, 크림·골드 세리프 타이포, 얇은 선과 넓은 여백.
 */
import styled from 'styled-components';

export const M = {
  bg: '#f6f3f1',
  card: '#ffffff',
  text: '#2a1216',
  muted: '#7d6d6f',
  line: '#e7dddb',
  red: '#b3121f',
  redDark: '#8e0d18',
  cream: '#f6e9cf',
  gold: '#c9a86a',
  warnBg: '#fdeee8',
  warnLine: '#eab5a2',
  warnText: '#c0391b',
  serif: "'Didot','Bodoni MT','Playfair Display','Noto Serif KR','Nanum Myeongjo',Georgia,serif",
};

export const Page = styled.div`
  padding: 16px 18px 92px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-size: 15px;
  color: ${M.text};
  .s { color: ${M.muted}; font-size: 13px; line-height: 1.5; }
`;

/** 섹션 제목 — 세리프 + 얇은 골드 라인 */
export const H = styled.h2`
  font-family: ${M.serif};
  font-size: 22px;
  font-weight: 500;
  letter-spacing: 0.02em;
  padding-bottom: 8px;
  border-bottom: 1px solid ${M.gold};
`;

export const Eyebrow = styled.div`
  font-size: 11px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: ${M.muted};
`;

/** 상단 대표 수치 — 딥 레드 바탕에 크림/골드 세리프 (참고 사이트의 레드 박스 + 골드 타이포) */
export const Hero = styled.div`
  background: linear-gradient(160deg, ${M.red} 0%, ${M.redDark} 100%);
  color: ${M.cream};
  padding: 22px 20px;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-shadow: 0 10px 24px -14px rgba(142, 13, 24, 0.7);
  .k { font-size: 11px; letter-spacing: 0.24em; text-transform: uppercase; color: ${M.gold}; }
  .v { font-family: ${M.serif}; font-size: 34px; letter-spacing: 0.01em; }
  .v.neg { color: #ffc9b8; }
  .sub { font-size: 12px; color: rgba(246, 233, 207, 0.75); }
`;

export const CardBox = styled.div`
  border: 1px solid ${(p) => (p.$warn ? M.warnLine : M.line)};
  border-radius: 2px;
  background: ${(p) => (p.$warn ? M.warnBg : M.card)};
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  ${(p) => (p.$tap ? 'cursor:pointer;' : '')}
  .t { font-weight: 600; letter-spacing: 0.01em; }
  .s { color: ${M.muted}; font-size: 13px; }
  .n { font-family: ${M.serif}; font-size: 24px; }
  .neg { color: ${M.warnText}; }
  .lab { font-size: 11px; letter-spacing: 0.18em; text-transform: uppercase; color: ${M.muted}; }
`;

export const Grid2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
`;

export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 11px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${M.muted};
  select,
  input,
  textarea {
    min-height: 46px;
    font-size: 16px;
    letter-spacing: 0;
    text-transform: none;
    border: 1px solid ${M.line};
    border-radius: 2px;
    padding: 0 12px;
    color: ${M.text};
    background: #fff;
    &:focus { outline: none; border-color: ${M.red}; }
  }
`;

export const Btn = styled.button`
  min-height: 46px;
  padding: 0 18px;
  border-radius: 2px;
  border: 1px solid ${(p) => (p.$primary ? M.red : M.text)};
  background: ${(p) => (p.$primary ? M.red : 'transparent')};
  color: ${(p) => (p.$primary ? M.cream : M.text)};
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.12em;
  &:active { background: ${(p) => (p.$primary ? M.redDark : '#efe8e6')}; }
  &:disabled { opacity: 0.4; }
`;

export const Chip = styled.span`
  display: inline-block;
  font-size: 11px;
  letter-spacing: 0.08em;
  padding: 2px 8px;
  border-radius: 2px;
  border: 1px solid ${(p) => (p.$warn ? M.warnLine : M.line)};
  background: ${(p) => (p.$warn ? M.warnBg : '#faf6f4')};
  color: ${(p) => (p.$warn ? M.warnText : M.muted)};
`;
